import { b as p, a as T } from "./objectWithoutPropertiesLoose-1e2b28af.js";
import * as R from "react";
import { c as _ } from "./clsx-0c6e471a.js";
import { P as o } from "./index-057d60ee.js";
import { s as E } from "./styled-a6aa6ca0.js";
import { u as N } from "./useThemeProps-14bb9b11.js";
import { l as M, f as u, g as S } from "./createTheme-ef7fa3a1.js";
import { g as U } from "./generateUtilityClasses-b12a03ea.js";
import { jsx as j } from "react/jsx-runtime";
import { c as A } from "./composeClasses-8a61f9a6.js";
import { keyframes as v, css as f } from "@emotion/react";
function I(e, t = 0, n = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > n) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${n}].`), M(e, t, n);
}
function V(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((r) => r + r)), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((r, a) => a < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function w(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return w(V(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(n) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : u(9, e));
  let r = e.substring(t + 1, e.length - 1), a;
  if (n === "color") {
    if (r = r.split(" "), a = r.shift(), r.length === 4 && r[3].charAt(0) === "/" && (r[3] = r[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(a) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${a}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : u(10, a));
  } else
    r = r.split(",");
  return r = r.map((i) => parseFloat(i)), {
    type: n,
    values: r,
    colorSpace: a
  };
}
function D(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: r
  } = e;
  return t.indexOf("rgb") !== -1 ? r = r.map((a, i) => i < 3 ? parseInt(a, 10) : a) : t.indexOf("hsl") !== -1 && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), t.indexOf("color") !== -1 ? r = `${n} ${r.join(" ")}` : r = `${r.join(", ")}`, `${t}(${r})`;
}
function P(e, t) {
  return e = w(e), t = I(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, D(e);
}
function X(e) {
  return String(e).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function F(e) {
  return parseFloat(e);
}
function W(e) {
  return S("MuiSkeleton", e);
}
U("MuiSkeleton", ["root", "text", "rectangular", "rounded", "circular", "pulse", "wave", "withChildren", "fitContent", "heightAuto"]);
const B = ["animation", "className", "component", "height", "style", "variant", "width"];
let l = (e) => e, g, m, b, y;
const K = (e) => {
  const {
    classes: t,
    variant: n,
    animation: r,
    hasChildren: a,
    width: i,
    height: s
  } = e;
  return A({
    root: ["root", n, r, a && "withChildren", a && !i && "fitContent", a && !s && "heightAuto"]
  }, W, t);
}, L = v(g || (g = l`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`)), q = v(m || (m = l`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`)), z = E("span", {
  name: "MuiSkeleton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], n.animation !== !1 && t[n.animation], n.hasChildren && t.withChildren, n.hasChildren && !n.width && t.fitContent, n.hasChildren && !n.height && t.heightAuto];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  const n = X(e.shape.borderRadius) || "px", r = F(e.shape.borderRadius);
  return p({
    display: "block",
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: e.vars ? e.vars.palette.Skeleton.bg : P(e.palette.text.primary, e.palette.mode === "light" ? 0.11 : 0.13),
    height: "1.2em"
  }, t.variant === "text" && {
    marginTop: 0,
    marginBottom: 0,
    height: "auto",
    transformOrigin: "0 55%",
    transform: "scale(1, 0.60)",
    borderRadius: `${r}${n}/${Math.round(r / 0.6 * 10) / 10}${n}`,
    "&:empty:before": {
      content: '"\\00a0"'
    }
  }, t.variant === "circular" && {
    borderRadius: "50%"
  }, t.variant === "rounded" && {
    borderRadius: (e.vars || e).shape.borderRadius
  }, t.hasChildren && {
    "& > *": {
      visibility: "hidden"
    }
  }, t.hasChildren && !t.width && {
    maxWidth: "fit-content"
  }, t.hasChildren && !t.height && {
    height: "auto"
  });
}, ({
  ownerState: e
}) => e.animation === "pulse" && f(b || (b = l`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), L), ({
  ownerState: e,
  theme: t
}) => e.animation === "wave" && f(y || (y = l`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), q, (t.vars || t).palette.action.hover)), $ = /* @__PURE__ */ R.forwardRef(function(t, n) {
  const r = N({
    props: t,
    name: "MuiSkeleton"
  }), {
    animation: a = "pulse",
    className: i,
    component: s = "span",
    height: c,
    style: C,
    variant: k = "text",
    width: x
  } = r, h = T(r, B), d = p({}, r, {
    animation: a,
    component: s,
    variant: k,
    hasChildren: !!h.children
  }), O = K(d);
  return /* @__PURE__ */ j(z, p({
    as: s,
    ref: n,
    className: _(O.root, i),
    ownerState: d
  }, h, {
    style: p({
      width: x,
      height: c
    }, C)
  }));
});
process.env.NODE_ENV !== "production" && ($.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The animation.
   * If `false` the animation effect is disabled.
   * @default 'pulse'
   */
  animation: o.oneOf(["pulse", "wave", !1]),
  /**
   * Optional children to infer width and height from.
   */
  children: o.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: o.object,
  /**
   * @ignore
   */
  className: o.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: o.elementType,
  /**
   * Height of the skeleton.
   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
   */
  height: o.oneOfType([o.number, o.string]),
  /**
   * @ignore
   */
  style: o.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: o.oneOfType([o.arrayOf(o.oneOfType([o.func, o.object, o.bool])), o.func, o.object]),
  /**
   * The type of content that will be rendered.
   * @default 'text'
   */
  variant: o.oneOfType([o.oneOf(["circular", "rectangular", "rounded", "text"]), o.string]),
  /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: o.oneOfType([o.number, o.string])
});
const oe = $;
export {
  oe as S
};
//# sourceMappingURL=Skeleton-6fae696d.js.map
